import { render, staticRenderFns } from "./ProductAccordion.vue?vue&type=template&id=b9aa9966&scoped=true&"
import script from "./ProductAccordion.vue?vue&type=script&lang=ts&"
export * from "./ProductAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAccordion.vue?vue&type=style&index=0&id=b9aa9966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aa9966",
  null
  
)

export default component.exports